// extracted by mini-css-extract-plugin
export var active = "_u-8";
export var addWidgetButton = "_u-9";
export var backButton = "_u-1";
export var pageContainer = "_u-2";
export var settingsContent = "_u-0";
export var sideNavContainer = "_u-6";
export var sideNavLink = "_u-7";
export var widgetContainer = "_u-5";
export var widgetSubsectionItem = "_u-3";
export var widgetSubsectionItemContent = "_u-4";